import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import Btn from '../Button';

const Dropdowns = (props) => (
  <Dropdown {...props.attrDropDown} disabled={props.loading}>
    <Btn attrBtn={{ ...props.attrDropBtn, disabled: props.loading, style: { cursor: props.loading ? 'not-allowed' : 'pointer' } }}>
      {props.dropBtnContent}
    </Btn>
    {props.loading || (
      <DropdownMenu {...props.attrDropMenu}>
        {props.dropItem.map((item, i) =>
          <DropdownItem {...props.attrDropItem} onClick={item.onClick ?? props.attrDropItem.onClick} key={i}>{item.item}</DropdownItem>
        )}
      </DropdownMenu>
    )}
  </Dropdown>
);

export default Dropdowns;